import { useState } from "react";
import { IconButton, Button, Grid, FormControl, InputLabel, Select, MenuItem, TextField, TableContainer, Table, TableBody, Paper, TableCell, TableHead, TableRow, } from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { FPagarGrupaltyle } from "./FPagarGrupalStyles";
import { useFormik } from "formik";
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import { useDispatch } from "react-redux";
import { pagarCompraGrupal, obtenerItemsGrupal, cancelarCompraGrupal } from "./../../../ducks/finanzasDuck"
import MoneyIcon from '@material-ui/icons/Money';
import { formatDinero } from "./../../../utils/formatDinero"
import Avance from "../../../global/Avance"
import ButtonClienteDetalle from "../../../global/ButtonClienteDetalle";
import {onLoadAnction, offLoadAction} from "./../../../ducks/loadDuck"
const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Monto es requerido"),
});
const InitialValues = {
    monto: 1
}
const Formulario = (props) => {
    const {
        open = true,
        setOpen = () => { },
        Item = {}
    } = props;
    const dispatch = useDispatch()
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const classes = FPagarGrupaltyle()
    const [tipoMoneda, setTipoMoneda] = useState(0)

    const formik = useFormik({
        initialValues: InitialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSend(values)
        },
    })

    const handleCancel = (values) => {
        DialogMessage.fire({
            title: '¿Esta seguro de marcar este item como pagado?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({message: ""}))
                dispatch(cancelarCompraGrupal({
                    idPagoGrupal: Item.pagoGrupal?.idPagoGrupal
                })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "error",
                            title: Response.Message,
                        });
                        return null;
                    }
                    handleClose();
                    dispatch(obtenerItemsGrupal())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }

    const onSend = (values) => {
        DialogMessage.fire({
            title: '¿Esta seguro de marcar este item como pagado?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({message: ""}))
                dispatch(pagarCompraGrupal({
                    idPagoGrupal: Item.pagoGrupal?.idPagoGrupal,
                    TipoCambio: values.monto,
                })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "error",
                            title: Response.Message,
                        });
                        return null;
                    }
                    handleClose();
                    dispatch(obtenerItemsGrupal())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }

    const handleClose = () => {
        setOpen(false)
        formik.resetForm(InitialValues);
    }

    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }

    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo="Pagar Item"
            />
            <form onSubmit={formik.handleSubmit}>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", textAlign: "center" }}>
                            <div>
                                <p>No Pax total: <b>{`${Item.noPax}`}</b></p>
                                <p>Paquete: <b>{`${Item.compra?.paquete?.Nombre}`}</b></p>
                                <p>Cleve Viaje: <b>{`${Item.compra?.paquete?.ClaveViaje}`}</b></p>
                            </div>
                            <div>
                                <p>Motivo: <b>{`${Item.compra?.TipoCompra?.Descripcion}`}</b></p>
                                <p>Operador: <b>{`${Item.Proveedor}`}</b></p>
                                <p>Monto a pagar: <b>{`${formatDinero(Item.pagoGrupal?.Monto)}`} {`${Item.compra?.paquete?.MonedaProveedor?.Clave}`}</b></p>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer component={Paper} style={{ overflowY: "scroll", maxHeight: "350px" }}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Referencia</TableCell>
                                        <TableCell align="center">Nombre</TableCell>
                                        <TableCell align="center">No. pax</TableCell>
                                        <TableCell align="center">Monto</TableCell>
                                        <TableCell align="center">Ahorro</TableCell>
                                        <TableCell align="center">Avance</TableCell>
                                        <TableCell align="center">Estatus</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        Item?.listaCompraPagar.map((compra, index) =>
                                            <TableRow hover key={compra.meta?.Referencia}>
                                                <TableCell align="center">
                                                    <ButtonClienteDetalle referencia={`${compra.meta?.Referencia}`} />
                                                </TableCell>
                                                <TableCell align="center">{`${compra.meta?.contratacion?.Cliente}`}</TableCell>
                                                <TableCell align="center">{`${compra.paquete?.Numero_Personas}`}</TableCell>
                                                <TableCell align="center">{`${formatDinero(compra.paquete?.Monto_Paquete)} ${compra?.moneda?.Clave}`}</TableCell>
                                                <TableCell align="center">{`${formatDinero(compra.paquete?.Cotizacion?.Suma)} ${compra?.moneda?.Clave}`}</TableCell>
                                                <TableCell align="center"><Avance progress={compra.paquete?.Cotizacion?.Avance} /></TableCell>
                                                <TableCell align="center">{`${compra.paquete?.EstatusProceso?.Descripcion}`}</TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    {
                        (false) &&
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                <Select
                                    labelId="lTipoMoneda"
                                    id="STipoMoneda"
                                    name="tipoMoneda"
                                    value={tipoMoneda}
                                    onChange={handleSelecTipoMoneda}
                                    label="Moneda"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoMoneda.map((moneda, index) => (
                                        <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                            {`${moneda.Clave} - ${moneda.Descripcion}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    }
                    {
                        (false) && <Grid item xs={12}>
                            <TextField
                                required
                                id="input-Monto"
                                label="T.C. Al momento del pago:"
                                type="text"
                                variant="outlined"
                                name="monto"
                                value={formik.values.monto}
                                onChange={formik.handleChange}
                                error={formik.touched.monto && Boolean(formik.errors.monto)}
                                helperText={formik.touched.monto && formik.errors.monto}
                                className={classes.textField}
                                disabled={(Item.compra?.paquete?.MonedaProveedor?.id_moneda !== Item.compra?.paquete?.Cotizacion?.Moneda?.id_moneda)}
                            />
                        </Grid>
                    }

                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            Guardar
                        </Button>
                        <Button
                            onClick={handleCancel}
                            variant="contained"
                            className={classes.modalBoton}
                        >
                            Cancelar compra
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </ModalBase>
    )
}
const FPagarGrupal = (props) => {
    const { Item } = props
    const [open, setOpen] = useState(false)
    const onClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <IconButton variant="outlined" onClick={onClick}>
                <MoneyIcon color="secondary" />
            </IconButton>
            <Formulario
                Item={Item}
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
export default FPagarGrupal
